import React from "react";

export const getMenuTriggerComponent = (children: React.ReactNode) => {
  const comp = React.Children.toArray(children).find(
    (child) =>
      React.isValidElement(child) &&
      typeof child.type !== "string" &&
      (child?.type as { displayName?: string })?.displayName ===
        "DropdownMenuTrigger",
  );
  return comp ?? null;
};

export const getMenuContentComponent = (children: React.ReactNode) => {
  const comp = React.Children.toArray(children).find(
    (child) =>
      React.isValidElement(child) &&
      typeof child.type !== "string" &&
      (child?.type as { displayName?: string })?.displayName ===
        "DropdownMenuContent",
  );
  return comp ?? null;
};
